module.exports = __webpack_public_path__ + "img/phev.3248ae42.png";